"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: "#eee",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "12px"
  },
  info: {
    flexBasis: "100%"
  },
  typography: {
    display: "block",
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "normal",
    fontSize: "14px"
  },
  button: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "6px 9px",
    border: "1px solid"
  }
}));

const UserAppInfo = ({
  version = 1,
  date,
  onLogout
}) => {
  const classes = useStyles();
  return _react.default.createElement("footer", {
    className: classes.root
  }, _react.default.createElement("div", {
    className: classes.info
  }, _react.default.createElement(_Typography.default, {
    className: classes.typography
  }, _react.default.createElement("strong", null, "Version"), " ", version), _react.default.createElement(_Typography.default, {
    className: classes.typography,
    datetime: date
  }, _react.default.createElement("strong", null, "Date"), " ", date)), _react.default.createElement(_ButtonBase.default, {
    className: classes.button,
    onClick: onLogout
  }, "Logout"));
};

UserAppInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  version: _propTypes.default.string,
  date: _propTypes.default.string,
  onLogout: _propTypes.default.func
} : {};
var _default = UserAppInfo;
exports.default = _default;
module.exports = exports.default;